import all from './all';
import store from './store';
import update from './update';
import destroy from './destroy';
import show from './show';
import showMixPallet from './showMixPallet';

export default {
  all,
  store,
  update,
  destroy,
  show,
  showMixPallet,
};



// WEBPACK FOOTER //
// ./src/app/services/package/index.js